import app from './global/app.json';
import navigation from './global/navigation.json';
import welcome from './widget/welcome.json';
import automation from './widget/automation.json';
import registration from './widget/registration.json';

export default {
  app,
  navigation,
  page: {
    // Add here
  },
  widget: {
    welcome,
    automation,
    registration,
  },
};
